(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('SuperBillDiagnosis', SuperBillDiagnosis);

    SuperBillDiagnosis.$inject = ['$resource', 'DateUtils'];

    function SuperBillDiagnosis ($resource, DateUtils) {
        var resourceUrl =  'api/super-bill-diagnoses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertDateTimeFromServer(data.startDate);
                        data.endDate = DateUtils.convertDateTimeFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'create': {url: 'api/super-bill-diagnoses/create',  method:'POST'},
            'findAllBySuperBill': {method: 'GET', url: 'api/super-bill-diagnoses/by-super-bill/:id', isArray: true },
            'reorder': { method: 'POST', url: 'api/super-bill-diagnoses/reorder', isArray: false }
        });
    }
})();
